import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'MTM' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'MTM', label: 'Momentum', pane: 'sub', params: [12, 6], outputs: ['mtm', 'maMtm'] })
